import { KazooError } from "@kazoohr/types";

import {
  PossibleTypes,
  TypeScriptTypeFromString,
  hasProperty,
} from "./hasProperty";

export function assertHasProperty<
  TSubject,
  TKey extends string,
  TType extends PossibleTypes = "unknown"
>(
  obj: TSubject,
  key: TKey,
  type?: TType,
  errorMessage?: string,
  metadata?: Record<string, unknown>
): asserts obj is TSubject & Record<TKey, TypeScriptTypeFromString<TType>> {
  if (!hasProperty(obj, key, type)) {
    const err = errorMessage || `Expected ${key} to be ${type || "present"}.`;
    throw new KazooError(err, { ...metadata, key, type });
  }
}
